import React, { useState } from "react";
import {
  TextField, InputAdornment, IconButton, Accordion,
  AccordionSummary, AccordionDetails, Box, List, ListItem,
  ListItemText, Checkbox,
  Button
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ReplayIcon from '@mui/icons-material/Replay';
import { FilterType } from "../utils/filters"

type FilterBarProps = {
  filters: FilterType[];
  onFilterChange: (filters: Record<string, (string | number)[]>) => void;
  onSearchChange: (term: string) => void;
};

const drawerWidth = 400;
const collapsedWidth = 50;

const FilterBar: React.FC<FilterBarProps> = ({ filters, onFilterChange, onSearchChange }) => {
  const [open, setOpen] = useState(false);
  const [selectedFilters, setSelectedFilters] = useState<Record<string, (string | number)[]>>({});
  const [searchTerm, setSearchTerm] = useState('');

  const toggleDrawer = () => setOpen(!open);

  const resetFilters = () => {
    setSelectedFilters({});
    setSearchTerm('');
    onFilterChange({});
    onSearchChange('');
  };

  const handleCheckboxChange = (filterName: string, value: (string | number)) => {
    const currentValues: (string | number)[] = selectedFilters[filterName] || [];
    const newValues = currentValues.includes(value)
      ? currentValues.filter((v) => v !== value)
      : [...currentValues, value];

    const updatedFilters = {
      ...selectedFilters,
      [filterName]: newValues,
    };

    setSelectedFilters(updatedFilters);
    onFilterChange(updatedFilters);
  };

  return (

    <Box
      sx={{
        width: open ? drawerWidth : collapsedWidth,
        transition: "width 0.3s ease-in-out",
        overflowX: "hidden",
        overflowY: "hidden",
        display: open ? "" : "flex",
        flexDirection: "column",
        alignItems: open ? "flex-start" : "center",
        backgroundColor: "white",
        height: "100%",
        borderRadius: "15px",
        boxShadow: "2px 0px 5px rgba(0, 0, 0, 0.1)",
      }}>
      {!open && (<>
        <IconButton onClick={toggleDrawer} sx={{ mt: 1 }}>
          <SearchIcon />
        </IconButton>
        <button onClick={toggleDrawer}
          className="btn btn-light"
          style={{
            width: '30px',
            height: '100%',
            background: '#F3F3F3',
            borderRadius: '10px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: 10
          }}
        >
          <ChevronRightIcon />
        </button>
      </>
      )}


      {open && (
        <>
          <Box sx={{ padding: 2 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
              <IconButton onClick={resetFilters}>
                <ReplayIcon />
              </IconButton>
              <IconButton onClick={toggleDrawer}>
                <ChevronLeftIcon />
              </IconButton>
            </Box>

            <TextField
            sx={{marginTop:'24px'}}
              label="Nome esercizio"
              size="small"
              fullWidth
              value={searchTerm}
              onChange={(e) => {
                setSearchTerm(e.target.value);
                onSearchChange(e.target.value);
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            />
          </Box>

          <Box sx={{ overflowY: 'auto', height: 'calc(100% - 140px)' }}>
            <List sx={{ padding: 2 }}>
              {filters.map((filter, index) => (
                <Accordion
                  key={index}
                  sx={{
                    border: 'none',
                    boxShadow: 'none',
                    marginBottom: 2,
                    background: '#F3F3F3',
                    borderRadius: 2,
                    '&::before': {
                      display: 'none',
                    },
                  }}
                >
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      {filter.name}
                      {(selectedFilters[filter.key] || []).length > 0 && (
                        <Box
                          sx={{
                            width: 10,
                            height: 10,
                            bgcolor: 'green',  
                          }}
                        />
                      )}
                    </Box>
                  </AccordionSummary>
                  <AccordionDetails>
                    <List sx={{ padding: 0 }}>
                      {filter.subFilters.map((sub, subIndex) => (
                        <ListItem
                          key={subIndex}
                          dense
                          sx={{
                            borderBottom: 'none',
                            paddingY: 0.5,
                          }}
                        >
                          <Checkbox
                            checked={(selectedFilters[filter.key] || []).includes(sub)}
                            onChange={() => handleCheckboxChange(filter.key, sub)}
                          />
                          <ListItemText primary={sub} />
                        </ListItem>
                      ))}
                    </List>
                  </AccordionDetails>
                </Accordion>
              ))}
            </List>
          </Box>
        </>
      )}
    </Box>
  );
};

export default FilterBar;
